/**
 * Checks if an error is a timeout error.
 * Also checks error.cause to handle wrapped errors (e.g., ApiError wrapping DOMException).
 */
export function isTimeoutError(error: unknown): boolean {
  if (isTimeoutErrorInstance(error)) {
    return true;
  }

  // Check one level deep for wrapped errors (e.g., ApiError wrapping DOMException)
  if (error instanceof Error && error.cause) {
    return isTimeoutErrorInstance(error.cause);
  }

  return false;
}

function isTimeoutErrorInstance(error: unknown): boolean {
  // AbortSignal.timeout() throws a DOMException with name "TimeoutError"
  if (error instanceof DOMException && error.name === 'TimeoutError') {
    return true;
  }

  // Manual abort via AbortController throws DOMException with name "AbortError"
  if (error instanceof DOMException && error.name === 'AbortError') {
    return true;
  }

  // Fallback: check for timeout in error message
  if (error instanceof Error && error.message?.toLowerCase().includes('timeout')) {
    return true;
  }

  return false;
}
